/** Stable analytics keys - decouple trackCTAClick from display copy (FR-10). */
export const CTA_KEYS = {
  primaryContact: 'primary_contact_cta',
  requestAssessment: 'request_modernization_assessment',
  talkToArchitect: 'talk_to_architect',
  exploreAccelerators: 'explore_accelerators',
  viewSuccessStories: 'view_success_stories',
  scheduleArchitectureReview: 'schedule_architecture_review',
  generateMigrationBlueprint: 'generate_migration_blueprint',
  exploreMigrationStrategy: 'explore_migration_strategy',
  startConversation: 'start_conversation',
} as const;
export type CtaKey = (typeof CTA_KEYS)[keyof typeof CTA_KEYS];

/** Display labels for common CTAs */
export const CTA_LABELS = {
  requestAssessment: 'Request a Modernization Assessment',
  talkToArchitect: 'Talk to an Architect',
  scheduleArchitectureReview: 'Schedule an Architecture Review',
  generateMigrationBlueprint: 'Generate a Migration Blueprint',
  exploreMigrationStrategy: 'Explore Your Migration Strategy',
  startConversation: 'Talk to an Architect',
} as const;
